export default "__VITE_ASSET__864c66a7__"